export const customRole = suspendedReason => {
  let role = window.reactGlobals.customRole;

  if (window.reactGlobals.isMdnDisconnected || suspendedReason) {
    if (window.reactGlobals.amRole === "prepay") {
      role = "prepay_disconnected";
    } else {
      role = "disconnected";
    }
  }

  return role;
};
